import './api/fetchInterceptor';
import ReportesIngresosDiariosScreen from './screens/ReportesIngresosDiariosScreen/ReportesIngresosDiariosScreen';
import ReporteAuditoriaScreen from './screens/ReporteAuditoriaScreen/ReporteAuditoriaScreen';
import React from "react";
import "./index.css";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, ProtectedRoute, useAuth, hasStudentRole } from "./api/AuthContext";
import { SidebarProvider } from "./components/Sidebar";
import HeaderGlobal from './components/HeaderGlobal';
import Sidebar from "./components/Sidebar";

// Importa tus pantallas
import BuildManagement from "./screens/BuildManagementScreen/BuildManagement";
import PantallaDeCampus from "./screens/CampusScreen/PantallaDeCampus";
import PantallaSeccionesAcademicas from "./screens/SeccionesScreen/PantallaDeSecciones";
import PantallaDeCiclos from "./screens/CiclosScreen/PantallaDeSecciones";
import PantallaPeriodos from "./screens/PeriodosScreen/PantallaPeriodos";
import ConceptosCobroScreen from "./screens/ConceptosCobroScreen/ConceptosCobroScreen";
import BecasScreen from "./screens/BecasScreen/BecasScreen";
import AsignacionBecasScreen from './screens/AsignacionBecasScreen/AsignacionBecasScreen';
import InscripcionReinscripcionScreen from './screens/InscripcionReinscripcionScreen/InscripcionReinscripcionScreen';
import RolesPermissionsScreen from './screens/RolesPermissionsScreen/RolesPermissionsScreen';
import GestionInteresadosScreen from './screens/GestionInteresadosScreen/GestionInteresadosScreen';
import PreasignacionMateriasScreen from './screens/PreasignacionMateriasScreen/PreasignacionMateriasScreen';
import AsignacionGruposScreen from './screens/AsignacionGruposScreen/AsignacionGruposScreen';
import CambioGrupoScreen from './screens/CambioGrupoScreen/CambioGrupoScreen';
import BajaReactivacionScreen from './screens/BajaReactivacionScreen/BajaReactivacionScreen';
import AdmisionEstudiantesScreen from './screens/AdmisionEstudiantesScreen/AdmisionEstudiantesScreen';
import CierreCicloEscolarScreen from './screens/CierreCicloEscolarScreen/CierreCicloEscolarScreen';
import AplicacionPagosScreen from './screens/AplicacionPagosScreen/AplicacionPagosScreen';
import GeneracionCargosManualesScreen from './screens/GeneracionCargosManualesScreen/GeneracionCargosManualesScreen';
import GeneracionCargosAutomaticosScreen from './screens/GeneracionCargosAutomaticosScreen/GeneracionCargosAutomaticosScreen';
import EstudiantesScreen from './screens/EstudiantesScreen/EstudiantesScreen';
import EstudiantesConsultaScreen from './screens/EstudiantesConsultaScreen/EstudiantesConsultaScreen';
import PortalEstudiantesScreen from './screens/PortalEstudiantesScreen/PortalEstudiantesScreen';
import GestionUsuariosScreen from './screens/GestionUsuariosScreen/GestionUsuariosScreen';
import RestablecerContrasenaScreen from './screens/RestablecerContraseñaScreen/RestablecerContrasenaScreen';
import PantallaGruposEstudiantes from './screens/ReportesGruposEstudiantes/PantallaGruposEstudiantes';
import FirmaConcetradosScreen from './screens/FirmaConcetradosScreen/FirmaConcetradosScreen';
import ReporteEstudiantesInscritosScreen from './screens/ReporteEstudiantesInscritosScreen/ReporteEstudiantesInscritosScreen';
import ReporteNuevosIngresosScreen from './screens/ReporteNuevosIngresosScreen/ReporteNuevosIngresosScreen';
import ReporteBecasScreen from './screens/ReporteBecasScreen/ReporteBecasScreen';

import PantalladeLogin from './screens/pantallade-login';
import RecuperacionContraseña from './screens/recuperacion_contraseña';
import PantallaDeInicio from './screens/pantalla_inicio';
import PantallaDeProgramasAcademicos from './screens/AcademicosScreen/PantallaAcademicos';
import PantallaDeMaterias from './screens/MateriasScreen/PantallaMaterias';
import PantallaDeAsignacionProgramaMateria from './screens/AsignacionProgramasScreen/PantallaDeAsignacionProgramaMateria';
import PantallaDeDocentes from './screens/DocentesScreen/PantallaDeDocentes';
import PantallaDeGrupos from './screens/GruposScreens/PantallaDeGrupos';
import PantallaInstituciones from './screens/InstitucionesScreen/PantallaInstituciones';
import PantallaDeAcademias from './screens/AcademiasScreen/PantallaDeAcademias';
import RegistroCalificacionesScreen from './screens/RegistroCalificacionesScreen/RegistroCalificacionesScreen';
import CalificacionesEscolarScreen from './screens/CalificacionesEscolarScreen/CalificacionesEscolarScreen';
import ReporteCalificacionesScreen from './screens/ReporteCalificacionesScreen/ReporteCalificacionesScreen';
import ReporteCargaAcademicaScreen from './screens/ReporteCargaAcademicScreen/ReporteCargaAcademicaScreen';
import ReporteEstudiantesCarreraScreen from './screens/ReporteEstudiantesCarreraScreen/ReporteEstudiantesCarreraScreen';
import ReporteEficienciaScreen from './screens/ReporteEficienciaScreen/ReporteEficienciaScreen';
import ReporteEstimacionAlumnadoScreen from './screens/ReporteEstimacionAlumnadoScreen/ReporteEstimacionAlumnadoScreen';
import ReporteSegurosEstudiantesScreen from './screens/ReporteSegurosEstudiantesScreen/ReporteSegurosEstudiantesScreen';
import ReporteSeguroAsesoresScreen from './screens/ReporteSeguroAsesoresScreen/ReporteSeguroAsesoresScreen';
import RegistroAsistenciasScreen from './screens/RegistroAsistenciasScreen/RegistroAsistenciasScreen';
import ReportesFinancierosScreen from './screens/ReportesFinancierosScreen/ReportesFinancierosScreen';
import ReporteAdeudosScreen from './screens/ReporteAdeudosScreen/ReporteAdeudosScreen';
import ReporteRectoriaScreen from './screens/ReporteRectoriaScreen/ReporteRectoriaScreen';
import ConstanciasScreen from './screens/ConstanciasScreen/ConstanciasScreen';
import InscripcionNuevoScreen from './screens/InscripcionNuevoScreen/InscripcionNuevoScreen';
import MateriasEquivalentesScreen from './screens/MateriasEquivalentesScreen/MateriasEquivalentesScreen';
import TramitesEscolaresScreen from './screens/TramitesEscolaresScreen/TramitesEscolaresScreen';

// Monta la raíz de la app
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

// Componente para la ruta principal
function HomeRedirect() {
  const { user } = useAuth();
  if (user) {
    // Si el usuario es estudiante, mostrar el portal especial
    if (hasStudentRole(user)) {
      return (
        <>
          <HeaderGlobal title="Portal de Estudiantes" />
          <PortalEstudiantesScreen />
        </>
      );
    }
    return <Navigate to="/inicio" replace />;
  }
  return <PantalladeLogin />;
}

function AppWithSidebar() {
  const { user } = useAuth();
  const isSysUser = !!(user && (user.isSysUser || user.id_usuario || user.id_rol));
  const isStudent = hasStudentRole(user);
  const showSidebar = isSysUser && !isStudent;

  return (
    <SidebarProvider>
      <Router>
        <Routes>
          {/* Pantalla principal */}
          <Route path="/" element={<HomeRedirect />} />

          {/* Pantalla de login explícita */}
          <Route path="/login" element={<PantalladeLogin />} />

          {/* Pantalla de recuperación */}
          <Route path="/recuperar" element={<RecuperacionContraseña />} />

          {/* Pantalla de restablecer contraseña (primer acceso) */}
          <Route path="/restablecer-contrasena" element={<ProtectedRoute element={<RestablecerContrasenaScreen />} allowFirstAccess={true} />} />

          {/* Pantalla inicio */}
          <Route path="/inicio" element={<ProtectedRoute element={<PantallaDeInicio />} />} /> 

          {/* ===== CONSULTA ===== */}
          <Route path="/consulta/estudiantes" element={<ProtectedRoute element={<EstudiantesConsultaScreen />} modulo="Consulta" />} />

          {/* ===== CONTROL ESCOLAR ===== */}
          <Route path="/programas" element={<ProtectedRoute element={<PantallaDeProgramasAcademicos />} modulo="Control Escolar" />} />
          <Route path="/materias" element={<ProtectedRoute element={<PantallaDeMaterias />} modulo="Control Escolar" />} />
          <Route path="/asignacion-programa-materia" element={<ProtectedRoute element={<PantallaDeAsignacionProgramaMateria />} modulo="Control Escolar" />} />
          <Route path="/estudiantes" element={<ProtectedRoute element={<EstudiantesScreen />} modulo="Control Escolar" />} />
          <Route path="/calificaciones-escolar" element={<ProtectedRoute element={<CalificacionesEscolarScreen />} modulo="Control Escolar" />} />
          <Route path="/reporte-calificaciones" element={<ProtectedRoute element={<ReporteCalificacionesScreen />} modulo="Perfil Académico" />} />

          {/* ===== PERFIL ACADÉMICO ===== */}
          <Route path="/grupos" element={<ProtectedRoute element={<PantallaDeGrupos />} modulo="Perfil Académico" />} />
          <Route path="/docentes" element={<ProtectedRoute element={<PantallaDeDocentes />} modulo="Perfil Académico" />} />
          <Route path="/preasignacion-materias" element={<ProtectedRoute element={<PreasignacionMateriasScreen />} modulo="Perfil Académico" />} />
          <Route path="/asignacion-grupos" element={<ProtectedRoute element={<AsignacionGruposScreen />} modulo="Perfil Académico" />} />
          <Route path="/reporte-carga-academica" element={<ProtectedRoute element={<ReporteCargaAcademicaScreen />} modulo="Perfil Académico" />} />
          <Route path="/reporte-estudiantes-carrera" element={<ProtectedRoute element={<ReporteEstudiantesCarreraScreen />} modulo="Perfil Académico" />} />
          <Route path="/materias-equivalentes-revalidar" element={<ProtectedRoute element={<MateriasEquivalentesScreen />} modulo="Perfil Académico" />} />
          <Route path="/reporte-seguros-estudiantes" element={<ProtectedRoute element={<ReporteSegurosEstudiantesScreen />} modulo="Finanzas" />} />
          <Route path="/reporte-seguros-asesores" element={<ProtectedRoute element={<ReporteSeguroAsesoresScreen />} modulo="Finanzas" />} />

          {/* ===== PANEL ASESOR ===== */}
          <Route path="/firma-concetrados" element={<ProtectedRoute element={<FirmaConcetradosScreen />} modulo="Panel Asesor" />} />
          <Route path="/registro-calificaciones" element={<ProtectedRoute element={<RegistroCalificacionesScreen />} modulo="Panel Asesor" />} />
          <Route path="/registro-asistencias" element={<ProtectedRoute element={<RegistroAsistenciasScreen />} modulo="Panel Asesor" />} />

          {/* ===== ADMINISTRACIÓN DEL SISTEMA - CATÁLOGOS ===== */}
          <Route path="/instituciones" element={<ProtectedRoute element={<PantallaInstituciones />} modulo="Administración del Sistema" />} />
          <Route path="/campus" element={<ProtectedRoute element={<PantallaDeCampus />} modulo="Administración del Sistema" />} />
          <Route path="/secciones-academicas" element={<ProtectedRoute element={<PantallaSeccionesAcademicas />} modulo="Administración del Sistema" />} />
          <Route path="/periodos" element={<ProtectedRoute element={<PantallaPeriodos />} modulo="Administración del Sistema" />} />
          <Route path="/ciclos-escolares" element={<ProtectedRoute element={<PantallaDeCiclos />} modulo="Administración del Sistema" />} />
          <Route path="/conceptos-cobro" element={<ProtectedRoute element={<ConceptosCobroScreen />} modulo="Administración del Sistema" />} />
          <Route path="/becas" element={<ProtectedRoute element={<BecasScreen />} modulo="Administración del Sistema" />} />
          <Route path="/academias" element={<ProtectedRoute element={<PantallaDeAcademias />} modulo="Administración del Sistema" />} />

          {/* ===== FINANZAS ===== */}
          <Route path="/inscripcion-reinscripcion" element={<ProtectedRoute element={<InscripcionReinscripcionScreen />} modulo="Finanzas" />} />
          <Route path="/asignacion-becas" element={<ProtectedRoute element={<AsignacionBecasScreen />} modulo="Finanzas" />} />
          <Route path="/generacion-cargos-manuales" element={<ProtectedRoute element={<GeneracionCargosManualesScreen />} modulo="Finanzas" />} />
          <Route path="/aplicacion-pagos" element={<ProtectedRoute element={<AplicacionPagosScreen />} modulo="Finanzas" />} />
          <Route path="/reporte-ingresos-diarios" element={<ProtectedRoute element={<ReportesIngresosDiariosScreen />} modulo="Finanzas" />} />
          <Route path="/reporte-adeudos" element={<ProtectedRoute element={<ReporteAdeudosScreen />} modulo="Finanzas" />} />
          <Route path="/generacion-cargos-automaticos" element={<ProtectedRoute element={<GeneracionCargosAutomaticosScreen />} modulo="Finanzas" />} />
          <Route path="/reportes-financieros" element={<ProtectedRoute element={<ReportesFinancierosScreen />} modulo="Finanzas" />} />
          <Route path="/inscripcion-nuevo" element={<ProtectedRoute element={<InscripcionNuevoScreen />} modulo="Finanzas" />} />
          <Route path="/reporte-rectoria" element={<ProtectedRoute element={<ReporteRectoriaScreen />} modulo="Administración del Sistema" />} />

          {/* ===== ADMISIONES ===== */}
          <Route path="/admision-estudiantes" element={<ProtectedRoute element={<AdmisionEstudiantesScreen />} modulo="Admisiones" />} />
          <Route path="/gestion-interesados" element={<ProtectedRoute element={<GestionInteresadosScreen />} modulo="Admisiones" />} />

          {/* ===== OTROS (Temporal) ===== */}
          <Route path="/cambio-grupos" element={<ProtectedRoute element={<CambioGrupoScreen />} modulo="Otros" />} />
          <Route path="/baja-reactivacion" element={<ProtectedRoute element={<BajaReactivacionScreen />} modulo="Control Escolar" />} />
          <Route path="/cierre-ciclo-escolar" element={<ProtectedRoute element={<CierreCicloEscolarScreen />} modulo="Otros" />} />
          <Route path="/portal-estudiantes" element={<ProtectedRoute element={<PortalEstudiantesScreen />} modulo="Otros" />} />
          <Route path="/reporte-grupos-estudiantes" element={<ProtectedRoute element={<PantallaGruposEstudiantes />} modulo="Otros" />} />

          {/* ===== ADMINISTRACIÓN DEL SISTEMA ===== */}
          <Route path="/gestion-usuarios" element={<ProtectedRoute element={<GestionUsuariosScreen />} modulo="Administración del Sistema" />} />
          <Route path="/roles-permisos" element={<ProtectedRoute element={<RolesPermissionsScreen />} modulo="Administración del Sistema" />} />

          {/* ===== CONSTANCIAS ===== */}
          <Route path="/constancias" element={<ProtectedRoute element={<ConstanciasScreen />} modulo="Control Escolar" />} />

          {/* ===== REPORTES ===== */}
          <Route path="/reportes/grupos-estudiantes" element={<ProtectedRoute element={<PantallaGruposEstudiantes />} modulo="Reportes" />} />

          {/* ===== REPORTE DE BECAS ===== */}
          <Route path="/reporte-becas" element={<ProtectedRoute element={<ReporteBecasScreen />} modulo="Finanzas" />} />
          <Route path="/reporte-estudiantes-inscritos" element={<ProtectedRoute element={<ReporteEstudiantesInscritosScreen />} modulo="Control Escolar" />} />
          <Route path="/reporte-estimacion-alumnado" element={<ProtectedRoute element={<ReporteEstimacionAlumnadoScreen />} modulo="Control Escolar" />} />
          <Route path="/reporte-estudiantes-nuevo-ingreso" element={<ProtectedRoute element={<ReporteNuevosIngresosScreen />} modulo="Control Escolar" />} />
          <Route path="/reporte-eficiencia-terminal" element={<ProtectedRoute element={<ReporteEficienciaScreen />} modulo="Control Escolar" />} />
          <Route path="/tramites-escolares" element={<ProtectedRoute element={<TramitesEscolaresScreen />} modulo="Control Escolar" />} />
          <Route path="/reporte-auditoria" element={<ProtectedRoute element={<ReporteAuditoriaScreen />} modulo="Administración del Sistema" />} />

          {/* Build Management (sin restricción de módulo) */}
          <Route path="/build" element={<ProtectedRoute element={<BuildManagement />} />} />
        </Routes>
      </Router>
    </SidebarProvider>
  );
}

root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppWithSidebar />
    </AuthProvider>
  </React.StrictMode>
);
